import BaseContainer from "@base/container/BaseContainer";
import ParallaxContainer from "./ParallaxContainer";
import * as PIXI from "pixi.js";

export default class GameBackgroundContainer extends BaseContainer {

  constructor(data = null) {
    super(data)

    this.init()
  }

  init() {
    const moon = new PIXI.Sprite(PIXI.Texture.from('moon'))
    moon.name = 'moon'
    moon.scale.set(0.6)
    moon.position.set(670, 100)

    this.addChild(moon)

    const bg = new ParallaxContainer()
    this.addChild(bg)
 }
}
